module.exports = __webpack_public_path__ + "static/media/left-arrow.308640c7.svg";